import pinSelected from "../../icons/pin-selected.svg";
import pin from "../../icons/pin.svg";
import './style.css'

const Index = ({
                   object,
                   selectedObject,
                   loading,
                   setObject,
                   style,
               }) => {
    const select = () => {
        if (setObject && !loading) {
            setObject(object)
        }
    }


    return <div key={object.id} className={"object"} style={style} onClick={e => select()}>
        <div className={"object-info"}>
            <div>
                <div className={"vehicle-route"} style={{paddingBottom: 8}}>
                    <div className={"vehicle-route-number"}>{object.name}</div>
                </div>
                <div className={"vehicle-station"}>
                    <div
                        className={"vehicle-station-text"}>{object.description}
                    </div>
                </div>
            </div>
            {setObject && <div className={"object-selection"}>
                <div className={"object-pin"}>
                    {object.id === selectedObject?.id ?
                        <img style={{display: "block", height: 24, width: 24}} src={pinSelected}/> :
                        <img style={{display: "block", height: 24, width: 24}} src={pin}/>}
                </div>
            </div>}
        </div>
    </div>
}

export default Index